import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  LEVEL_PUBLISHED,
  PARAM_CLIENTS_PATH,
  PARAM_PAGES_PATH,
  STATE_PAGES_PUBLISHED,
  STATE_PUBLISHED,
} from "src/app/admin/constants/constants";
import { Clients } from "src/app/models/clients";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { environment } from "src/environments/environment";
import { PagesService } from "src/app/services/pages.service";
import { Pages } from "src/app/models/pages";
import { Page } from "src/app/cmspage/page";

import { DynamicFiltersComponent } from "src/app/components/dynamic-filters/dynamic-filters.component";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DrawerModule } from "primeng/drawer";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { NgxPaginationModule } from "ngx-pagination";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";

@Component({
    selector: "app-manage-pages",
    templateUrl: "./manage-pages.component.html",
    imports: [DynamicFiltersComponent, ButtonModule, ConfirmDialogModule, DrawerModule, SharedModule, FormsModule, InputTextModule, NgxPaginationModule, Ripple, RouterLink, SelectModule, TableModule, ToastModule]
})
export class ManagePagesComponent extends AbstractListController<Pages, any> {
  title = "Pages";
  client: Clients;
  productDialog: boolean = false;
  imageUrl: string;
  statePublished: any[];
  levelPublished: any[];
  pages: Pages[];

  constructor(
    protected pagesService: PagesService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(pagesService, confirmationService, router, route, PARAM_PAGES_PATH);
    this.loadPages();

    this.cols.set([
      { field: "page_title", header: "Titolo" },
      { field: "page_order", header: "Ordine" },
      { field: "is_active", header: "Attivo" },
      { field: "is_featured", header: "Featured" },
    ]);
    this.colsFilter.set([
      { field: "id", header: "Id", type: "string" },
      { field: "page_title", header: "Titolo", type: "string" },
      { field: "mother_page_id", header: "Pagina madre", type: "select", option: [] },
    ]);
    this.imageUrl = environment.news_image_url;

    this.statePublished = STATE_PAGES_PUBLISHED;
    this.levelPublished = LEVEL_PUBLISHED;
  }



  loadPages(): void {
    const params = {
      page: 0,
      size: 1000,
    };
    this.pagesService.list(params).subscribe((pData) => {
      this.pages = pData;
      this.colsFilter.update((cols) =>
        cols.map((c) =>
          c.field === "mother_page_id"
            ? { ...c, option: pData.map((p) => ({ label: p.page_title, value: p.id })) }
            : c
        )
      );
    });
  }


}
